export default __webpack_public_path__ + "static/media/ue-plugin-icon.2cd2c6bf.svg";